export default __webpack_public_path__ + "static/media/Icon_Receipt.92f13d01.svg";